import Objective from "../../../../../src/components/Objective";
import Progress from "../../../../../src/components/Progress";
import Result from "../../../../../src/components/Result";
import Current from "../../../../../src/components/Current";
import Score from "../../../../../src/components/Score";
import Goal from "../../../../../src/components/Goal";
import Due from "../../../../../src/components/Due";
import Okr from "../../../../../src/components/Okr";
import Row from "../../../../../src/components/Row";
import { Playground, Props } from "docz";
import { dateOptions, metrics, results, grades } from "../../../../../src/data/example.js";
import * as React from 'react';
export default {
  Objective,
  Progress,
  Result,
  Current,
  Score,
  Goal,
  Due,
  Okr,
  Row,
  Playground,
  Props,
  dateOptions,
  metrics,
  results,
  grades,
  React
};